import styles from './FeaturesWide.module.scss';
import { ButtonType } from '@/components/Button/Button';
import Text from '@/components/Text/Text';

interface IFeatures {
  title: string,
  description: string,
  cards: {
    id: number,
    title: string,
    description: string,
    button: {
      id: number;
      title: string;
      type: ButtonType;
      link: string;
    },
  }[]
}

const FeaturesWide = ({ data }: { data: IFeatures }) => (
  <section className={styles.features}>
    <div className={styles.textContent}>
      {data.description && (
      <Text
        tag='p'
        className={styles.tagline}
      >
        {data.description}
      </Text>
      )}
      <Text
        tag='h2'
        className={styles.title}
      >
        {data.title}
      </Text>
    </div>
    <ul className={styles.featuresList}>
      {data.cards.slice(0, 4).map((card) => (
        <li
          key={card.id}
          className={styles.featuresCard}
        >
          <div className={styles.featuresCardContent}>
            <h4>{card.title}</h4>
            <p>{card.description}</p>
          </div>
        </li>
      ))}
    </ul>

  </section>
);

export default FeaturesWide;
